import { Container, Flex } from '@chakra-ui/react';
import { useState } from 'react';

import { FilterTile } from './FilterTile';
import { DateRangeFilter } from './DateRangeFilter';
import { TravelersFilter } from './TravelersFilter';
import { DestinationFilter } from './DestinationFilter';
import { Button } from 'components/Button';
import { SearchIcon } from '@chakra-ui/icons';
import { HotelFilters } from 'hooks';

const FILTERS = {
    DESTINATION: 'destination',
    DATES: 'dates',
    TRAVELERS: 'travelers',
};

type StaysFilterProps = {
    onChange: (filters: HotelFilters) => void;
};

const StaysFilter = ({ onChange }: StaysFilterProps) => {
    const [activeFilter, setActiveFilter] = useState('');
    const [filters, setFilters] = useState<HotelFilters>({destination: '', dates: {startDate:undefined, endDate: undefined}, travelers: ''});

    const onSearch = () => {
        onChange(filters);
    };

    return (
      <Container
        display='flex'
        borderRadius='100px'
        alignItems='center'
        backgroundColor='rgba(249, 249, 249, 0.25)'
        boxShadow='0px 20px 25px -5px rgba(151, 151, 151, 0.1), 0px 10px 10px -5px rgba(151, 151, 151, 0.04)'
        maxW='container.xl'
        marginBottom='60px'
        justifyContent='center'
        padding={0}
        gap={2}
      >
        <FilterTile
          onOpen={setActiveFilter}
          title='Destination'
          active={activeFilter === FILTERS.DESTINATION}
          subtitle='Search destination'
        >
          <DestinationFilter
            placeholder='Leaving from'
            onChange={(value) => setFilters({ ...filters, [FILTERS.DESTINATION]: value })}
          />
        </FilterTile>
        <FilterTile
          onOpen={setActiveFilter}
          title='Depart - Return'
          active={activeFilter === FILTERS.DATES}
          subtitle='When?'
        >
          <DateRangeFilter onChange={(value) => setFilters({ ...filters, [FILTERS.DATES]: value })} />
        </FilterTile>
        <FilterTile
          onOpen={setActiveFilter}
          title='Travelers'
          active={activeFilter === FILTERS.TRAVELERS}
          subtitle='How many?'
        >
          <TravelersFilter onChange={(value) => setFilters({ ...filters, [FILTERS.TRAVELERS]: value })} />
        </FilterTile>
        <Flex justifyContent='center' paddingLeft='20px' paddingRight='20px'>
          <Button label='Search' onClick={onSearch} variant='solid' size='lg' colorScheme='blue' icon={<SearchIcon />} />
        </Flex>
      </Container>
    );
}

export {StaysFilter};